import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { starlightCurve } from "./icons/starlightcurve";
import { starlightLogo } from "./icons/starlightlogo";
import { starBig } from "./icons/starbig";
import { starSmall } from "./icons/starsmall";
import { moon } from "./icons/moon";
import { verticleCurve } from "./icons/verticlecurve";
import { starpurple } from "./icons/starpurple";
import { starlightphoto } from "./icons/starlightphoto";
import { starRotatedSmall } from "./icons/starrotatedsmall";

@customElement("starlight-banner")
export class StarlightBanner extends LitElement {
  override createRenderRoot() {
    return this;
  }

  @property()
  starlightInfo: any = [];

  override render() {
    return html`
      <div class="twf-mx-4 md:twf-mx-6 xl:twf-mx-8">
        <div
          id="starlight-banner"
          class="twf-relative md:twf-h-[200px] lg:twf-max-w-[1320px] twf-mx-auto twf-py-6 md:twf-py-0 twf-px-4 md:twf-px-0 md:twf-rounded-l-3xl twf-bg-cr-purple-500 twf-rounded-b-2xl twf-rounded-t-3xl twf-mb-8 twf-text-white twf-text-center md:twf-text-left twf-text-xl"
        >
          <a
            href="https://join.cashrewards.com.au/starlight-cashrewards-partnership"
            target="_blank"
          >
            <div
              class="twf-bg-[#F8F2FF] twf-h-full twf-w-[120px] twf-rounded-l-2xl twf-absolute twf-top-0 twf-left-0 twf-hidden md:twf-block"
            ></div>
            ${starlightCurve()} ${verticleCurve()} ${starlightLogo()}
            <div class="twf-absolute  twf-h-full twf-w-full twf-truncate">
              ${starBig()} ${starSmall()} ${starRotatedSmall()} ${moon()}
            </div>
            ${starpurple()} ${starlightphoto()}
            <div
              class="twf-pt-20 twf-px-2 md:twf-pl-0 twf-relative md:twf-ml-[268px] md:twf-pr-[10px] lg:twf-pr-[248px] md:twf-pt-[28px]"
            >
              ${this.starlightInfo[0]?.label}
            </div>
            <div
              class="twf-font-bold twf-px-2 md:twf-pl-0 twf-relative md:twf-ml-[268px] md:twf-pr-[24px] lg:twf-pr-[248px]"
            >
              ${this.starlightInfo[1]?.label}
            </div>
            <button
              class="twf-rounded-lg twf-font-bold twf-mt-[20px] twf-h-[40px] twf-w-[101px] md:twf-ml-[268px] twf-bg-[#F8F2FF] twf-text-cr-purple-500 twf-text-[16px] twf-px-2"
            >
              Learn More
            </button>
          </a>
        </div>
      </div>
    `;
  }
}
